import './about-us.css'
import pic1 from '../../../static/pic1.png';
const AboutUs =() => {
  return(
    <>
    <div class="aboutus">
      <div class = "about-text">
       <h2>About us</h2>
       <p>Hey there! We are a group of passionate psychology students at the University of Washington.</p>
       <p>We aim to build a community for UW student researchers. We help them collect research surveys and get results faster.</p>
       </div>
       <div class = "about-image">
       <img src ={pic1} id="mountain" alt="mountain"/>
       </div>
    </div>
    <div class="ins">
       <h2 id="insp">Our inspiration</h2>
       <p>During our time at UW, we found that student researchers at UW have a hard time gathering survey responses from their desired target group on time. A survey collection platform for UW students can go a long way to making their research life much easier. So, they can spend more time analyzing meaningful insights to make a difference in their academic fields.</p>
    </div>
    </>
  )
}

export default AboutUs;